import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PanAppState } from '@panamax/app-state';
import { Observable, of } from 'rxjs';
import { PageTitle } from 'src/app/shared/constants/page-titles.enum';
import { RebateTakeoutOptions } from '../models/rebates-takeout-options.enum';

@Injectable({
  providedIn: 'root',
})
export class RebatesResolverService {
  constructor(
    private panAppState: PanAppState,
    private router: Router,
    private translateService: TranslateService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<number> {
    if (!this.isValidTakeoutOption(route)) {
      this.router.navigate(['/desktop/404']);
      return of(0);
    }
    const takeoutOption = this.getTakeoutOptionFromRoute(route);
    const pageTitles = {
      [RebateTakeoutOptions.GrowWithUs]: PageTitle.getToKnowUs,
      [RebateTakeoutOptions.PartnerWithUs]: PageTitle.partnerWithUs,
    };
    this.panAppState.setPageTitle(
      this.translateService.instant(pageTitles[takeoutOption]),
    );
    return of(takeoutOption);
  }

  getTakeoutOptionFromRoute(route: ActivatedRouteSnapshot): number {
    const takeoutOption = parseInt(route.paramMap.get('takeoutOption'), 10);
    return takeoutOption;
  }

  isValidTakeoutOption(route: ActivatedRouteSnapshot): boolean {
    return Object.values(RebateTakeoutOptions).includes(
      parseInt(route.paramMap.get('takeoutOption'), 10),
    );
  }
}
